export default __webpack_public_path__ + "static/media/Group 383.70335c4c.svg";